import { Modal } from "antd";
import React from "react";

const VariabilityIndexContent: React.FC = () => {
  return (
    <div>
      <div className="svg-wrapper">
        <svg
          width="27"
          height="30"
          viewBox="0 0 27 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.106771 24.6774L10.6667 14.1176V17.8909L1.98677 26.5574C1.53344 26.4374 1.1201 26.1974 0.786771 25.8774C0.466771 25.5441 0.226771 25.1308 0.106771 24.6774Z"
            fill="#0071CD"
          />
          <path
            d="M10.6667 3.84004L0 14.5066V18.28L10.6667 7.61337V3.84004Z"
            fill="#0071CD"
          />
          <path
            d="M2.66667 2.66667C1.2 2.66667 0 3.86667 0 5.33333V8L5.33333 2.66667H2.66667Z"
            fill="#0071CD"
          />
          <path
            d="M8.38672 26.6667L10.6667 26.6667V24.3868L8.38672 26.6667Z"
            fill="#0071CD"
          />
          <path d="M10.6667 0H13.3333V29.3333H10.6667V0Z" fill="#0071CD" />
          <path
            d="M16 8V5.33333L21.3333 5.33333V2.66667H24V5.33333L26.6667 5.33333V8H24V21.3333H26.6667V24H24V26.6667H21.3333V24H16V21.3333H21.3333V8L16 8Z"
            fill="#0071CD"
          />
        </svg>
      </div>
      <h6>Variability Index</h6>
      <p>
        Variability index measures how variable the crop performance is in the
        field. A higher number means the field is highly variable and is more
        likely to benefit from Precision Farming approaches.
      </p>
      <p>
        The variability index is calculated based on a measure of how
        heterogeneous the crop performance is within the field, and how
        consistent that heterogeneity has been over time.The index uses NDVI
        data from the last 5 years and ranges from 0 to 1.
      </p>
      <p>
        A field with a high Variability Index means that:
        <br />- The field has contrasting zones with low and high productivity
        <br />- Those zones were in the same part of the field across seasons
        For a field with a Variability Index higher than 0.65, we recommend
        using variable seeding rates via Cropwise Planting.
      </p>
    </div>
  );
};

const HeterogeneityIndexContent: React.FC = () => {
  return (
    <div>
      <div className="svg-wrapper">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.84 0L0 11.84V15.6133L15.6133 0H11.84ZM22.0134 0.104167L0.106771 22.0108C0.226771 22.4642 0.466771 22.8775 0.786771 23.2108C1.1201 23.5308 1.53344 23.7708 1.98677 23.8908L23.9068 1.98417C23.6534 1.06417 22.9334 0.344167 22.0134 0.104167ZM0 2.66667C0 1.2 1.2 0 2.66667 0H5.33333L0 5.33333V2.66667ZM21.3333 24C22.0667 24 22.7333 23.7067 23.2133 23.2133C23.7067 22.7333 24 22.0667 24 21.3333V18.6667L18.6667 24H21.3333ZM12.16 24H8.38667L24 8.38667V12.16L12.16 24Z"
            fill="#0071CD"
          />
        </svg>
      </div>
      <h6>Heterogeneity Index</h6>
      <p>
        The Heterogeneity Index measures how heterogeneous the field has been in
        terms of crop performance.
      </p>
      <p>
        The heterogeneity index utilizes data from the last 5 years and scales
        from 0 and 1.
      </p>
      <p>
        A higher heterogeneity means that crop performance across the field has
        been highly variable. Low values indicate that crop performance across
        the field has been rather consistent.
      </p>
    </div>
  );
};

const ConsistencyIndexContent: React.FC = () => {
  return (
    <div>
      <div className="svg-wrapper">
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 13.333C23.6799 13.3332 26.666 16.3201 26.666 20C26.6658 23.6797 23.6797 26.6658 20 26.666C16.3201 26.666 13.3332 23.6799 13.333 20C13.333 16.32 16.32 13.333 20 13.333ZM5.33301 0V2.66602H18.666V0H21.333V2.66602H24V5.33301H21.333V10.7607C20.8977 10.6985 20.4526 10.667 20 10.667C19.5473 10.667 19.1015 10.6984 18.666 10.7607V5.33301H5.33301V18.666H10.7607C10.6984 19.1015 10.666 19.5472 10.666 20C10.666 20.4526 10.6985 20.8976 10.7607 21.333H5.33301V24H2.66602V21.333H0V18.666H2.66602V5.33301H0V2.66602H2.66602V0H5.33301ZM19.333 16V20.2666L22.1992 23.1328L23.1328 22.1865L20.666 19.7197V16H19.333Z"
            fill="#0071CD"
          />
        </svg>
      </div>
      <h6>Consistency index</h6>
      <p>
        Consistency index answers the question if the field zones of various
        productivity remain consistent over time.
      </p>
      <p>
        The consistency index utilizes data from the last 5 years and scales
        from 0 and 1.
      </p>
      <p>
        Low values indicate that the areas of the field that had higher or lower
        crop performance have changed over time, whereas higher values mean that
        those areas have stayed in similar locations over time and are more
        consistent.
      </p>
    </div>
  );
};

interface ModalInfoProps {
  isOpen: boolean;
  type: string;
  onClose: () => void;
}

const ModalInfo: React.FC<ModalInfoProps> = ({ isOpen, type, onClose }) => {
  return (
    <Modal
      open={isOpen}
      onCancel={() => {
        onClose();
      }}
      footer={null}
      centered
      className="info-modal"
      title={"What we assessed?"}
    >
      <div>
        {type === "heterogeneity" && <HeterogeneityIndexContent />}
        {type === "consistency" && <ConsistencyIndexContent />}
        {type === "variability" && <VariabilityIndexContent />}
      </div>
    </Modal>
  );
};

export default ModalInfo;
